import _ArrowUpDownIcon from "@adsk/alloy-react-icon/es/lib/ArrowUpDownIcon";
import _ArrowDownIcon from "@adsk/alloy-react-icon/es/lib/ArrowDownIcon";
import _ArrowUpIcon from "@adsk/alloy-react-icon/es/lib/ArrowUpIcon";
import _styled, { default as _styled2 } from "styled-components";
var _templateObject;
const _excluded = ["tableSize", "size", "isPlaceholder", "hasSubHeaders", "canResize", "isResizingColumn", "isResizingAnyColumn", "handleResize", "canSort", "isSorted", "toggleSort", "renderValue", "children", "style"];
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import theme, { stylePropType } from '@adsk/alloy-react-theme';
import { SORT_DIRECTIONS, TABLE_SIZES } from '../consts';
import getTableTheme from '../helpers/getTableTheme';
const preventTextHighlight = e => {
  e.preventDefault();
};
const TableHeader = _ref => {
  let {
      tableSize,
      size,
      isPlaceholder,
      hasSubHeaders,
      canResize,
      isResizingColumn,
      isResizingAnyColumn,
      handleResize,
      canSort,
      isSorted,
      toggleSort,
      renderValue,
      children,
      style
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const tableSizeTheme = getTableTheme(tableSize);
  const isPrimaryRow = !isPlaceholder && !hasSubHeaders;
  return /*#__PURE__*/React.createElement(_StyledTh, _extends({
    onMouseDown: e => {
      if (canSort && !isResizingAnyColumn) {
        toggleSort === null || toggleSort === void 0 ? void 0 : toggleSort(e);
      }
    }
  }, props, {
    $_css: [_objectSpread(_objectSpread(_objectSpread({
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      position: 'relative',
      width: size,
      flex: "".concat(size, " 0 auto"),
      borderBottomWidth: 1,
      borderBottomStyle: 'solid',
      backgroundColor: theme.tokens.colors.background.primary.value,
      '.tableHeaderCellSortIcon': {
        marginLeft: 'auto',
        minWidth: 20
      },
      padding: "0 ".concat(tableSizeTheme.cellPadding, "px")
    }, canResize ? {
      '&:hover': {
        '& > [role="separator"]': {
          backgroundColor: theme.tokens.colors.border.subtle.value
        }
      }
    } : {}), canSort ? {
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: theme.tokens.colors.background.neutral.hover.value,
        '& > .tableHeaderCellUnsortedIcon': {
          // display: 'inherit',
          visibility: 'visible'
        },
        '& > [role="separator"]': {
          backgroundColor: theme.tokens.colors.border.subtle.value
        }
      }
    } : {}), isPrimaryRow ? {
      fontWeight: theme.typography.bodySmallBold.fontWeight,
      borderColor: theme.tokens.colors.border.subtle.value
    } : {
      fontWeight: theme.typography.bodySmall.fontWeight,
      borderColor: theme.tokens.colors.border.subtler.value,
      borderRightWidth: 1,
      borderRightStyle: 'solid',
      borderRightColor: theme.tokens.colors.border.subtler.value,
      justifyContent: 'center',
      '&:last-child': {
        borderRightWidth: 0
      }
    }), style]
  }), children || !isPlaceholder && /*#__PURE__*/React.createElement(React.Fragment, null, renderValue === null || renderValue === void 0 ? void 0 : renderValue(), canSort && (() => {
    switch (isSorted) {
      case SORT_DIRECTIONS.ASC:
        return /*#__PURE__*/React.createElement(_ArrowUpIcon, {
          size: 20,
          className: "tableHeaderCellSortIcon"
        });
      case SORT_DIRECTIONS.DESC:
        return /*#__PURE__*/React.createElement(_ArrowDownIcon, {
          size: 20,
          className: "tableHeaderCellSortIcon"
        });
      default:
        return /*#__PURE__*/React.createElement(_ArrowUpDownIcon, {
          className: "tableHeaderCellSortIcon tableHeaderCellUnsortedIcon",
          size: 20,
          style: {
            visibility: 'hidden'
          }
        });
    }
  })()), canResize &&
  /*#__PURE__*/
  // Will be fixed in https://jira.autodesk.com/browse/DSGN-1840
  // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
  React.createElement(_StyledDiv, {
    role: 'separator',
    onMouseDown: e => {
      e.stopPropagation();
      preventTextHighlight(e);
      handleResize === null || handleResize === void 0 ? void 0 : handleResize(e);
    },
    onClick: e => e.stopPropagation(),
    onTouchStart: handleResize,
    $_css2: [_objectSpread(_objectSpread({
      zIndex: 1,
      width: 3,
      height: '100%',
      position: 'absolute',
      right: 0
    }, isResizingColumn ? {
      background: theme.tokens.colors.border.selected.subtle.value
    } : {}), {}, {
      '&:hover': {
        cursor: 'col-resize'
      }
    })]
  }));
};
TableHeader.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isPlaceholder: PropTypes.bool,
  hasSubHeaders: PropTypes.bool,
  canResize: PropTypes.bool,
  isResizingColumn: PropTypes.bool,
  isResizingAnyColumn: PropTypes.bool,
  handleResize: PropTypes.func,
  canSort: PropTypes.bool,
  isSorted: PropTypes.oneOf([...Object.values(SORT_DIRECTIONS), false]),
  toggleSort: PropTypes.func,
  renderValue: PropTypes.func,
  tableSize: PropTypes.oneOf(Object.values(TABLE_SIZES)),
  children: PropTypes.any,
  style: stylePropType
};
export default TableHeader;
var _StyledTh = _styled("th")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), p => p.$_css);
var _StyledDiv = _styled2("div").withConfig({
  displayName: "TableHeader___StyledDiv",
  componentId: "sc-1d0vko3-0"
})(["", ""], p => p.$_css2);
//# sourceMappingURL=TableHeader.js.map